import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Sparkles, Loader2 } from "lucide-react";

export const AISummary = ({ page }) => {
  const { api } = useAuth();
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(true);
  const [aiEnabled, setAiEnabled] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      try {
        const response = await api.post(`/ai/summary?page=${page}`);
        setSummary(response.data.summary);
        setAiEnabled(response.data.ai_enabled);
      } catch (error) {
        console.error("Failed to fetch AI summary:", error);
        setSummary("Welcome! Let's explore your finances together.");
        setAiEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [api, page]);

  if (loading) {
    return (
      <div className="ai" data-testid="ai-summary-loading">
        <div className="spark"><Loader2 className="w-4 h-4 animate-spin" style={{color:"#3F7D52"}} /></div>
        <div className="txt" style={{opacity:.5}}>Thinking...</div>
      </div>
    );
  }

  return (
    <div className="ai" data-testid="ai-summary">
      <div className="spark"><Sparkles className="w-4 h-4" style={{color:"#3F7D52"}} /></div>
      <div className="txt"><em>Tally insight</em>{summary}</div>
    </div>
  );
};

export default AISummary;
